import { render, staticRenderFns } from "./ModalVendorSelect.vue?vue&type=template&id=038ecb90&"
import script from "./ModalVendorSelect.vue?vue&type=script&lang=js&"
export * from "./ModalVendorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports